export const INITIAL_ARTICLE_DATA = {
  id: 0,
  title: '',
  slug: '',
  body: '',
  active: 0,
  created_at: '',
  updated_at: '',
  thumbnail: {
    id: 0,
    article_id: 0,
    URL: '',
    thumbnail: false,
    created_at: '',
    updated_at: '',
    signed_url: '',
  },
  categories: [],
  tags: [],
  images: [],
  variants: [],
};
